import React from 'react';
import FormsElementContainer, { FormsElementContainerModifier } from '../FormsElementContainer/FormsElementContainer';
import { ButtonActionConfirm } from '../../../Btn/ButtonWrapper';

type FormSubmitButtonProps = {
  buttonLabel: string;
  ariaDescribedBy?: string;
  enabled: boolean;
};

export function FormSubmitButton({ buttonLabel, ariaDescribedBy, enabled }: FormSubmitButtonProps) {
  return (
    <FormsElementContainer modifier={FormsElementContainerModifier.BUTTON_GROUP_RIGHT}>
      <span className="forms__button">
        <ButtonActionConfirm
          text={buttonLabel}
          ariaDisabled={!enabled}
          type={enabled ? 'submit' : 'button'}
          ariaDescribedBy={ariaDescribedBy}
        />
      </span>
    </FormsElementContainer>
  );
}
